import type { ColorModeTokens, ThemePreset } from "../tokens"

/**
 * Cyberpunk, imported from tweakcn
 * (https://tweakcn.com/r/themes/cyberpunk.json). Values kept in oklch as the
 * source provides them. Hot magenta primary on near-black purple, mint
 * accent, Google Sans display font (Outfit originally, replaced because it
 * has no Cyrillic).
 */
const light: ColorModeTokens = {
  background: "oklch(0.9816 0.0017 247.839)",
  foreground: "oklch(0.1649 0.0352 281.8285)",
  card: "oklch(1 0 0)",
  cardForeground: "oklch(0.1649 0.0352 281.8285)",
  popover: "oklch(1 0 0)",
  popoverForeground: "oklch(0.1649 0.0352 281.8285)",
  primary: "oklch(0.6726 0.2904 341.4084)",
  primaryForeground: "oklch(1 0 0)",
  primaryHover: "oklch(0.6231 0.2694 341.5)",
  secondary: "oklch(0.9595 0.02 286.0164)",
  secondaryForeground: "oklch(0.1649 0.0352 281.8285)",
  muted: "oklch(0.9595 0.02 286.0164)",
  mutedForeground: "oklch(0.4525 0.0425 280.5)",
  accent: "oklch(0.8903 0.1739 171.269)",
  accentForeground: "oklch(0.1649 0.0352 281.8285)",
  destructive: "oklch(0.6535 0.2348 34.037)",
  destructiveForeground: "oklch(1 0 0)",
  border: "oklch(0.9205 0.0086 225.0878)",
  input: "oklch(0.9205 0.0086 225.0878)",
  ring: "oklch(0.6726 0.2904 341.4084)",
  contrast: "oklch(0.1649 0.0352 281.8285)",
  contrastForeground: "oklch(0.9513 0.0074 260.7315)",
}

const dark: ColorModeTokens = {
  background: "oklch(0.1649 0.0352 281.8285)",
  foreground: "oklch(0.9513 0.0074 260.7315)",
  card: "oklch(0.2542 0.0611 281.1423)",
  cardForeground: "oklch(0.9513 0.0074 260.7315)",
  popover: "oklch(0.2542 0.0611 281.1423)",
  popoverForeground: "oklch(0.9513 0.0074 260.7315)",
  primary: "oklch(0.6726 0.2904 341.4084)",
  primaryForeground: "oklch(1 0 0)",
  primaryHover: "oklch(0.7152 0.2994 341.5)",
  secondary: "oklch(0.2542 0.0611 281.1423)",
  secondaryForeground: "oklch(0.9513 0.0074 260.7315)",
  muted: "oklch(0.2123 0.0522 280.9917)",
  mutedForeground: "oklch(0.6245 0.05 278.1046)",
  accent: "oklch(0.8903 0.1739 171.269)",
  accentForeground: "oklch(0.1649 0.0352 281.8285)",
  destructive: "oklch(0.6535 0.2348 34.037)",
  destructiveForeground: "oklch(1 0 0)",
  border: "oklch(0.3279 0.0832 280.789)",
  input: "oklch(0.3279 0.0832 280.789)",
  ring: "oklch(0.6726 0.2904 341.4084)",
  contrast: "oklch(0.2542 0.0611 281.1423)",
  contrastForeground: "oklch(0.9513 0.0074 260.7315)",
}

export const cyberpunkPreset: ThemePreset = {
  name: "cyberpunk",
  label: "Cyberpunk",
  light,
  dark,
  radius: 0.5,
  font: "google-sans",
}
